import { ActionButtonContent } from "../types/button-content"

export const actionContent: Record<string, ActionButtonContent> = {
  bill: {
    label: "Bill",
    description: "Generate and manage billing statements, invoices, or payment requests",
  },
  create: {
    label: "Create",
    description: "Add a new record, entry, or resource to the system",
  },
  createCustomer: {
    label: "Create customer",
    description: "Add a new customer to the system",
    variant: "secondary",
  },
  createSystem: {
    label: "Create system",
    description: "Create a new system",
    variant: "secondary",
  },
  createSite: {
    label: "Create site",
    description: "Add a new site to the system",
    variant: "secondary",
  },
  createAsset: {
    label: "Create asset",
    description: "Add a new asset to the system",
    variant: "secondary",
  },
  createFillingSite: {
    label: "Create filling site",
    description: "Add a new filling site to the system",
    variant: "secondary",
  },
  createLocation: {
    label: "Create location",
    description: "Add a new location to the system",
    variant: "secondary",
  },
  update: {
    label: "Update",
    description: "Modify existing data, settings, or configurations",
  },
  change: {
    label: "Change",
    description: "Alter status, state, or attributes of selected item",
  },
  changeStatus: {
    label: "Change status",
    description: "Alter the status of the selected item",
    variant: "primary",
  },
  scheduleService: {
    label: "Schedule next service",
    description: "Schedule a service for the selected item",
    variant: "secondary",
  },
  scheduleOrder: {
    label: "Schedule Order",
    description: "Schedule a new order",
    variant: "primary",
  },

  scheduleActivity: {
    label: "Schedule Activity",
    description: "Schedule a new activity",
    variant: "primary",
  },
  remove: {
    label: "Remove",
    description: "Delete selected item from the system",
  },
  archive: {
    label: "Delete",
    description: "Delete the selected item",
    variant: "warning",
  },
  cancel: {
    label: "Cancel",
    description: "Cancel the current action",
    variant: "secondary",
  },
  unassign: {
    label: "Unassign",
    description: "Unassign the selected item from the current object",
    variant: "secondary",
  },
  assign: {
    label: "Assign",
    description: "Assign the selected item",
    variant: "primary",
  },
  downloadCSV: {
    label: "Download full results (CSV)",
    description: "Download the full results as a CSV file",
    variant: "primary",
  },
  filter: {
    label: "Filter",
    description: "Filter the current view",
    variant: "primary",
  },
  newLocation: {
    label: "New location",
    description: "Create a new location",
    variant: "secondary",
  },
  selectLocation: {
    label: "Select location",
    description: "Select a location",
    variant: "secondary",
  },
  resetLocation: {
    label: "Reset",
    description: "Reset the location to the empty state",
    variant: "secondary",
  },
  assignLocation: {
    label: "Assign location",
    description: "Assign the current location",
    variant: "primary",
  },
  addActivity: {
    label: "Add activity",
    description: "Add a new activity",
    variant: "secondary",
  },
  addEvent: {
    label: "Add event",
    description: "Add a new event",
    variant: "primary",
  },
  confirm: {
    label: "Confirm",
    description: "Confirm the current action",
    variant: "primary",
  },
  complete: {
    label: "Complete",
    description: "Complete the current action",
    variant: "primary",
  },
  back: {
    label: "Back",
    description: "Go back to the previous page",
    variant: "secondary",
  },
  refresh: {
    label: "Refresh",
    description: "Refresh the current data",
    variant: "primary",
  },
  next: {
    label: "Next",
    description: "Proceed to the next step",
    variant: "primary",
  },
}

export default actionContent
